/**
 * Enumeration of supported languages in the application.
 * 
 * @enum {string}
 * @example
 * const language = Languages.ES; // "Español"
 * const language = Languages.EN; // "English"
 */
export enum Languages {
  ES = 'Español',
  EN = 'English'
}
